var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', _vm._b({}, 'sub-visual', _vm.visual, false)), _c('div', {
    staticClass: "client-content-wrap pb-0"
  }, [_c('section', {
    staticClass: "client-section pb-0"
  }, [_c('v-container', [_c('business-intro', _vm._b({}, 'business-intro', _vm.intro, false))], 1)], 1)]), _c('div', {
    staticClass: "client-content-wrap"
  }, [_c('scrolldown-tail'), _c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("주요 프로그램")])]), _c('v-row', _vm._l(_vm.programs, function (program, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "lg": "6"
      }
    }, [_c('v-card', {
      staticClass: "border-radius-16 text-center h-100 mx-auto",
      attrs: {
        "max-width": "588",
        "color": "#ddd",
        "outlined": ""
      }
    }, [_c('v-img', {
      attrs: {
        "src": program.image,
        "alt": ""
      }
    }), _c('v-card-title', {
      staticClass: "justify-center pt-lg-40"
    }, [_c('h3', {
      staticClass: "tit tit--sm primary--text"
    }, [_vm._v(" " + _vm._s(program.title) + " ")])]), _c('v-card-text', {
      staticClass: "pb-lg-40"
    }, [_c('p', {
      staticClass: "page-text page-text--lg",
      domProps: {
        "innerHTML": _vm._s(program.texts)
      }
    })])], 1)], 1);
  }), 1)], 1)], 1)], 1), _c('div', {
    staticClass: "client-content-wrap new-story"
  }, [_c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("새로운 변화의 이야기")]), _c('p', {
    staticClass: "tit tit--sm font-weight-medium mt-18 mt-md-24"
  }, [_vm._v(" 함께 가꾸는 지역사회, 모두를 위한 울타리 "), _c('br', {
    staticClass: "d-md-none"
  }), _vm._v(" With You, With Can ")])]), _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, _vm._l(_vm.stories, function (story, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "6",
        "lg": "4"
      }
    }, [_c('v-img', {
      staticClass: "border-radius-16 mx-auto",
      attrs: {
        "src": story,
        "alt": "",
        "max-width": "384"
      }
    })], 1);
  }), 1)], 1)], 1)]), _c('section', [_c('bottom-banner', {
    attrs: {
      "item": _vm.banner
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }